export default {
	"couponDialog.full": "full",
	"couponDialog.available": "available",
	"couponDialog.SendYou1Ticket": "Send you 1 ticket",
	"couponDialog.CouponsThatCanBeOrderedImmediately": "Coupons that can be ordered immediately"
}